import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { myAxios } from '../../services/Helper';
import './main_function.css';

const MainFunction = ({ selectedOccasion, onSelectOccasion }) => {
    const [functions, setFunctions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFunctions = async () => {
            try {
                const response = await myAxios.get('/function');
                if (response.status === 200) {
                    setFunctions(response.data.map(func => ({
                        id: func.functionId,
                        name: func.functionName,
                        price: Number(func.functionPrice) || 0
                    })));
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchFunctions();
    }, []);

    if (loading) return <div className="loading">Loading functions...</div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
        <div className="main-function-container">
            <h2 className="services-title">Functions</h2>
            <p className="services-subtitle">Select the function package for your event</p>

            <div className="services-card-grid" role="group" aria-labelledby="functionGroupLabel">
                <span id="functionGroupLabel" className="visually-hidden">Event Function Packages</span>

                {functions.map((service) => (
                    <div
                        key={service.id}
                        className={`service-card ${selectedOccasion === service.name ? 'selected' : ''}`}
                        role="option"
                        aria-selected={selectedOccasion === service.name}
                    >
                        <div className="service-card-content">
                            <h3 className="service-name">{service.name}</h3>
                            <div className="service-price">₹{service.price.toLocaleString()}</div>
                            <label htmlFor={`service-${service.id}`} className="visually-hidden">
                                Select {service.name} package
                            </label>
                            <button
                                className="add-to-cart-btn"
                                onClick={() => onSelectOccasion({
                                    id: service.id, // Add ID to payload

                                    name: service.name,
                                    price: service.price
                                })}
                                aria-labelledby={`service-${service.id}-label`}
                            >
                                <span id={`service-${service.id}-label`}>
                                    {selectedOccasion === service.name ? 'Selected' : 'Select Package'}
                                </span>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

MainFunction.propTypes = {
    selectedOccasion: PropTypes.string,
    onSelectOccasion: PropTypes.func.isRequired
};

export default MainFunction;

